import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { fetchSafeAPData } from '../logic/apiClass';
import { Button, Card, Col, Container, Row } from 'react-bootstrap';
import { Box, CircularProgress, Grid } from '@mui/material';
import { useWindowSize } from '@uidotdev/usehooks';
import "../../safeAPs/ui/SafeAPProfile.scss"
import dummyProfilePicture from "../../../../images/dummy-profile-picture.svg";
import { clearanceDecoder, formatPhoneNumber, prefixDecoder } from '../logic/utils';
import { CardSection } from '../../safeAPs/ui/SafeAPProfile';
import ProfileTabs from '../../../ProfileTabs';



const PublicProfile = () => {

    const { id } = useParams()
    const [data, setData] = useState({})
    const [loading, setLoading] = useState(true)
    const navigate = useNavigate()


    useEffect(() => {
        if (loading) {
            fetchSafeAPData(id, setData, setLoading, navigate)
        }
    }, [loading, id, navigate])

    useEffect(() => {
        setLoading(true)
    }, [id])

    // console.log(data)
    return (
        <Container>
            {
                (loading || JSON.stringify(data) === JSON.stringify({})) ?
                    <LoadingComponent /> :
                    <ProfileComponent safeAP={data} />
            }
        </Container>

    );
};

const ProfileComponent = ({ safeAP }) => {

    // console.log(safeAP)


    const filterProjectStatus = (projectArray, status) => {
        if (!projectArray || projectArray.length === 0) {
            return []
        } else {
            const array = projectArray.filter((project) =>
                (project.status === status)
            )
            return array
        }
    }
    return (<div style={{ marginBottom: "100px" }}>
        <Container fluid style={{ marginBottom: "20px", marginTop: "20px" }}>
            <Link to="/directory">
                <Button style={{ backgroundColor: "#14417C" }}>Back to directory</Button>

            </Link>

        </Container>
        <Container fluid >

            <div style={{ position: "relative", backgroundColor: "#112c54", height: 380, borderRadius: "10px", boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px" }}>

                <div className="safe-ap-profile-img">
                    <img
                        src={
                            safeAP.formData.img && safeAP.formData.img.length
                                ? safeAP.formData.img[0].content
                                : dummyProfilePicture
                        }

                    ></img>
                </div>



                <Card className="safe-ap-profile-main-section" style={{ position: "absolute", top: "50%", height: "50%", width: "100%", borderRadius: "10px" }}>
                    <Card.Body className="safe-profile-flex" >

                        <div className="safe-ap-profile-main-info" >
                            <div>
                                <h1>
                                    {" "}
                                    {prefixDecoder(safeAP.formData.prefix)}{safeAP.formData.firstName} {safeAP.formData.lastName}
                                </h1>
                                <br />

                                <div>

                                    {safeAP.formData.email}
                                </div>
                            </div>

                        </div>
                    </Card.Body>
                </Card>
            </div>




            <Row>
                <Col>
                    <Card className="safe-ap-profile-subsection" >


                        <Card.Body>
                            <div>
                                <h4>SafeAP Information</h4>

                            </div>
                            <hr></hr>
                            <div className="safeap-information-section">
                                <h6>Since</h6>
                                {safeAP.createdAt.toString().substring(0, 10)}
                            </div>
                            {
                                (safeAP.formData.address || safeAP.formData.zipPostalCode || safeAP.formData.city || safeAP.formData.stateProvince
                                    || safeAP.formData.country) ?
                                    <div className="safeap-information-section">
                                        <h6>Address</h6>

                                        {safeAP.formData.address ? safeAP.formData.address + " " : ""}{safeAP.formData.zipPostalCode ? safeAP.formData.zipPostalCode + ", " : ""}
                                        {safeAP.formData.city ? safeAP.formData.city + ", " : ""}{safeAP.formData.stateProvince ? safeAP.formData.stateProvince + ", " : ""}
                                        {safeAP.formData.country ? safeAP.formData.country : ""}
                                    </div>:
                                    null
                            }

                            {
                                safeAP.formData.phone &&
                                <div className="safeap-information-section">
                                    <h6>Phone</h6>
                                    {formatPhoneNumber(safeAP.formData.phone)}
                                </div>
                            }


                            {
                                safeAP.formData.safeap_service_area &&
                                <div className="safeap-information-section">
                                    <h6>SafeAP Service Area</h6>
                                    {safeAP.formData.safeap_service_area}
                                </div>
                            }

                            {
                                safeAP.formData.professional_designation &&
                                <div className="safeap-information-section">
                                    <h6>Professional Designations</h6>
                                    {safeAP.formData.professional_designation}
                                </div>
                            }
                            {
                                clearanceDecoder(safeAP.formData.security_clearance) ?
                                    <div className="safeap-information-section">
                                        <h6>Security Clearance</h6>
                                        {clearanceDecoder(safeAP.formData.security_clearance)}
                                    </div> :
                                    null
                            }

                        </Card.Body>
                    </Card>
                    <br />

                    <CardSection header={"Safe accredited courses"} array={safeAP.formData.courses ? safeAP.formData.courses : []} />
                    <br />
                    <CardSection header={"Education"} array={safeAP.formData.education ? safeAP.formData.education : []} />
                    <br />
                    <CardSection header={"Security related courses"} array={safeAP.formData.security_education ? safeAP.formData.security_education : []} />
                </Col>
                <Col>
                    <Card className="safe-ap-profile-subsection" >
                        <Card.Body>
                            <div className="safe-ap-profile-list-wrapper">
                                <h4>Projects</h4>
                                <div className="safe-ap-profile-list-content">
                                    <ProfileTabs>
                                        <div label="Active">
                                            <SafeAPProfileListSection
                                                listItems={filterProjectStatus(safeAP.projects, "active")}
                                                isProject={true}
                                            />
                                        </div>
                                        <div label="Completed">
                                            <SafeAPProfileListSection
                                                listItems={filterProjectStatus(safeAP.projects, "completed")}
                                                isProject={true}
                                            />
                                        </div>
                                    </ProfileTabs>
                                </div>
                            </div>
                        </Card.Body>


                    </Card>
                </Col>

            </Row>



        </Container>

    </div>)
}

const LoadingComponent = () => {
    const windowSize = useWindowSize()
    return (
        <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            minHeight={windowSize.height}
        >
            <Grid container columnSpacing={2}>
                <Grid item >
                    <CircularProgress />
                </Grid>
                <Grid item sx={{ paddingTop: "10px" }}>
                    <h3> Fetching data from server</h3>
                </Grid>
            </Grid>
        </Box>
    )
}


const SafeAPProfileListSection = ({ listItems, isProject }) => {



    if (listItems.length === 0) {
        return (
            <div>
                <Card className="safe-ap-profile-list-item" style={{ width: "100%" }}>
                    <Card.Body>
                        No {isProject ? <>projects</> : <>courses</>} yet
                    </Card.Body>
                </Card>
            </div>
        );
    }

    const renderedList = listItems.map((listItem, i) => {
        // console.log(listItem)
        const item = (

            <Card
                className="safe-ap-profile-list-item"
                style={{ width: "100%" }}
                key={i}
            >
                <Card.Body style={{ width: "100%" }}>
                    <div className="safe-ap-profile-list-item-content">
                        <div className="safe-ap-profile-list-item-img">
                            {/* {listItem.img.length && <img src={listItem.img[0].content} />} */}
                            <img
                                src={
                                    listItem.formData.img && listItem.formData.img.length
                                        ? listItem.formData.img[0].content
                                        : dummyProfilePicture
                                }
                                alt=""

                            ></img>
                        </div>
                        <div className="safe-ap-list-item-description" >
                            <h5>{listItem.formData.projectName}</h5>
                            {isProject ? (
                                <p>
                                    {listItem.formData.projectCity}, {listItem.formData.projectCountry}
                                </p>
                            ) : null}
                        </div>
                    </div>
                </Card.Body>
            </Card>


        );

        return item;
    });

    return <>{renderedList}</>;
};


export default PublicProfile;